import React from 'react';
import clsx from 'clsx';
import * as productStyles from '../../../styles/products/product-related-contents.module.scss';
import IconContainer from '../IconContainer';
import { useTranslation } from 'react-i18next';
import CkEditor from '../ckeditor/CkEditor';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import PropTypes from 'prop-types';

const ProductInfos = ({relatedContent}) => {
  const {t, i18n} = useTranslation();
  const activeLocale = i18n.resolvedLanguage;
  const parseDate = (date) => {
    return (new Date(date).toLocaleDateString(activeLocale, {
      day: '2-digit', month: 'long', year: 'numeric', timeZone:'CET'
    }));
  };

  const removeStyle = (el) => {
    if (el) {
      return el.replace(/(<([^>]+)>)/ig, '');
    }
    return el;
  };

  const getImageAlternativeText = (img) => {
    if(!img) return '';
    const alt = '';
    if (activeLocale === 'en') {
      if (img.getImageAlternativeTextEN) {
        return img.getImageAlternativeTextEN;
      }
    } else {
      if (img.getImageAlternativeText) {
        return img.getImageAlternativeText;
      }
    }
    return alt;
  };

  const getDuration = () => {
    if (relatedContent?.duration?.duration) {
      return `${relatedContent.duration.duration} ${t('product.info.days')}`;
    }
    return t('exed.product.sidebar.contact-us');
  };

  const getPrice = () => {
    if (relatedContent?.prices?.lastSessionPrice) {
      return `${relatedContent.prices.lastSessionPrice.toLocaleString(
        activeLocale,
        {
          style:'currency',
          currency:'EUR',
          minimumFractionDigits: 0
        }
      )}`;
    }
    return t('exed.product.sidebar.contact-us');
  };
  return (
    <div>
      <div className={productStyles.containerContent}>
        <div className={productStyles.containerCategory}>
          <div className={productStyles.categoryTitleContainer}>
            <IconContainer
              color="RED"
              icon="CALENDAR"
              noHover
              size={30}
              tabIndex={-1}
              variant="full"
            />
            <h2 className={productStyles.categoryTitle}>
              {t('product.info.next-sessions')}
            </h2>
          </div>
          <div className={productStyles.containerContentCategory}>
            {relatedContent?.sessions?.length > 0 &&
              <ul>
                {relatedContent.sessions.map((session, index) => (
                  <li className={productStyles.liste}
                    key={index + 'listDateProductInfos'}
                  >
                    <p className={productStyles.titleStart}>
                      {parseDate(session.date_begin)}
                    </p>
                    <p className={productStyles.text}>
                      {t(`exed.product.products.place.${session.place}`)}
                    </p>
                  </li>
                ))}
              </ul>
            }
            {relatedContent.sessions.length === 0 &&
                <ul>
                  <li className={productStyles.liste}
                    key="no-next-session-date"
                  >
                    <p className={productStyles.titleStart}>
                      {t('exed.product.sidebar.contact-us')}
                    </p>
                  </li>
                </ul>
            }
            {relatedContent.miscellaneous?.next_deadline &&
              <p className={productStyles.nextApp}>
                {t('exed.product.products.next-app')}&nbsp;:<br/>{parseDate(relatedContent.miscellaneous.next_deadline)}
              </p>
            }
          </div>
        </div>
        <div className={productStyles.containerCategory}>
          <div className={productStyles.categoryTitleContainer}>
            <IconContainer
              color="RED"
              icon="CLOCK"
              size={30}
              tabIndex={-1}
              variant="full"
            />
            <h2 className={productStyles.categoryTitle}>
              {t('product.info.duration')}
            </h2>
          </div>
          <div className={productStyles.containerContentCategory}>
            <p className={productStyles.titleStart}>
              {getDuration()}
            </p>
            <p
              className={productStyles.text}
              dangerouslySetInnerHTML={{
                __html: removeStyle(relatedContent.duration?.comment)
              }}
            />
          </div>
        </div>
        <div className={productStyles.containerCategory}>
          <div className={productStyles.categoryTitleContainer}>
            <IconContainer
              color="RED"
              icon="EURO"
              size={30}
              tabIndex={-1}
              variant="full"
            />
            <h2 className={productStyles.categoryTitle}>
              {t('product.info.fees')}
            </h2>
          </div>
          <div className={productStyles.containerContentCategory}>
            <p className={productStyles.titleStart}>
              {getPrice()}
            </p>
            {relatedContent?.prices?.details &&
              <div className={productStyles.ckeditorContainer}>
                <CkEditor html={relatedContent.prices.details}></CkEditor>
              </div>
            }
          </div>
        </div>
        {relatedContent.contacts && relatedContent.contacts.length > 0 &&
        <div className={productStyles.containerCategory}>
          <div className={productStyles.categoryTitleContainer}>
            <IconContainer
              color="RED"
              icon="MESSAGE"
              size={30}
              tabIndex={-1}
              variant="full"
            />
            <h2 className={productStyles.categoryTitle}>
              {t('product.info.contact')}
            </h2>
          </div>
          <div className={productStyles.containerContentCategory}>
            {relatedContent.contacts.map((c, index) => {
              return (
                <div className={productStyles.containerContact}
                  key={index + 'contact-product-info'}
                >
                  <div className={productStyles.containerContactText}>
                    <p className={productStyles.titleContact}>
                      {c.first_name + ' ' + c.last_name}
                    </p>
                    <p className={productStyles.textContact}>
                      {c.job}
                    </p>
                    <p className={productStyles.textContact}>
                      {c.phone}
                    </p>
                    <a className={productStyles.contactMail}
                      href={'mailto:' + c.mail}
                    >
                      {t('product.info.mailto')}
                    </a>
                  </div>
                  <GatsbyImage
                    alt={getImageAlternativeText(c.picture)}
                    className={productStyles.image}
                    image={getImage(c.picture?.imageFile)}
                    loading="eager"
                  />
                </div>
              );
            })}
          </div>
        </div>
        }
      </div>
      {relatedContent.info_meetings &&
        <div className={clsx(productStyles.containerCategoryInfo, productStyles.containerContent)}>
          <div className={productStyles.categoryTitleContainer}>
            <IconContainer
              color="RED"
              icon="CALENDAR"
              size={30}
              tabIndex={-1}
              variant="full"
            />
            <h2 className={productStyles.categoryTitle}>
              {t('product.info.info')}
            </h2>
          </div>
          <div className={clsx(productStyles.ckeditorContainer, productStyles.containerContentCategory)}>
            <CkEditor html={relatedContent.info_meetings}/>
          </div>
        </div>
      }
    </div>
  );
};


ProductInfos.propTypes = {
  relatedContent: PropTypes.shape({
    sessions: PropTypes.arrayOf(PropTypes.shape({
      date_begin: PropTypes.string.isRequired,
      place: PropTypes.string.isRequired,
    })).isRequired,
    duration: PropTypes.shape({
      duration: PropTypes.number,
      comment: PropTypes.string,
    }),
    prices: PropTypes.shape({
      lastSessionPrice: PropTypes.number,
      details: PropTypes.string,
    }),
    contacts: PropTypes.arrayOf(PropTypes.shape({
      first_name: PropTypes.string.isRequired,
      last_name: PropTypes.string.isRequired,
      job: PropTypes.string,
      phone: PropTypes.string,
      mail: PropTypes.string.isRequired,
      picture: PropTypes.shape({
        imageFile:PropTypes.object,
        getImageAlternativeText: PropTypes.string,
        getImageAlternativeTextEN: PropTypes.string,
      }),
    })),
    miscellaneous: PropTypes.shape({
      next_deadline: PropTypes.string
    }),
    info_meetings: PropTypes.string,
  }).isRequired,
};

export default ProductInfos;
